import type { Staff, HistoryItem } from '../services/types';

export const REASON_TAGS: string[] = [
  'Sick', 'Have lunch', 'Have dinner', 'My birthday', 'Family Problem',
];